/* ============================================================
   MODA Furnitures — Collection Tile AJAX Filtering
   File: Assets/moda-collection-tiles.js

   Replicates Kalles' native facet AJAX for our browse tiles:
   1. Intercept tile click
   2. Fetch the filtered URL via T4SThemeSP.getToFetchSection
   3. Swap the [data-contentlm-replace] product grid
   4. Update the URL bar + active tile state

   No drawer needed, no full reload. Falls back to normal
   navigation if anything is unavailable.
   ============================================================ */
(function () {
  'use strict';

  var GRID_SEL = '[data-contentlm-replace]';
  var PAG_SEL  = '.t4s-pagination-wrapper';

  function SP() { return window.T4SThemeSP; }

  function canAjax() {
    return SP() &&
           typeof SP().getToFetchSection === 'function' &&
           document.querySelector(GRID_SEL);
  }

  // Strip &view= for the fetch (keep it for the URL bar in staging)
  function cleanForFetch(href) {
    return href.replace(/([&?])view=[^&]*/g, function (m, p1) {
      return p1 === '?' ? '?' : '';
    }).replace(/[?&]$/, '');
  }

  function setActive(tile) {
    document.querySelectorAll('.moda-cl-tile').forEach(function (t) {
      t.classList.remove('is-active');
    });
    if (tile) tile.classList.add('is-active');
  }

  function showLoading(on) {
    var grid = document.querySelector(GRID_SEL);
    if (!grid) return;
    grid.style.transition = 'opacity .2s ease';
    grid.style.opacity = on ? '0.4' : '1';
    grid.style.pointerEvents = on ? 'none' : '';
  }

  // Read the collection section id from the DOM (e.g. template--123__main)
  function getSectionId() {
    var el = document.querySelector('[id^="shopify-section-template--"][id$="__main"]');
    if (!el) return null;
    // strip the "shopify-section-" prefix → "template--123__main"
    return el.id.replace('shopify-section-', '');
  }

  function doFilter(href, tile) {
    var fetchURL = cleanForFetch(href);

    // Build an ABSOLUTE url on the current origin so fetch resolves correctly.
    var absURL = fetchURL;
    if (absURL.charAt(0) === '/') {
      absURL = window.location.origin + absURL;
    }

    // Append &section_id= so Kalles renders the FULL section using the
    // template's pagination setting (numbered), not the default AJAX load-more.
    var sid = getSectionId();
    if (sid) {
      absURL += (absURL.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + encodeURIComponent(sid);
    }

    showLoading(true);
    setActive(tile);

    fetch(absURL, { method: 'GET', headers: { 'Cache-Control': 'no-cache' } })
      .then(function (r) {
        if (r.redirected) return 'NVT_94';
        return r.text();
      })
      .then(function (html) {
      if (!html || html === 'NVT_94') {
        // fetch failed — hard navigate as fallback
        window.location.href = fetchURL;
        return;
      }

      var doc = new DOMParser().parseFromString(html, 'text/html');
      var newGrid = doc.querySelector(GRID_SEL);
      var curGrid = document.querySelector(GRID_SEL);

      if (newGrid && curGrid) {
        curGrid.innerHTML = newGrid.innerHTML;
      } else {
        window.location.href = fetchURL;
        return;
      }

      // Swap pagination. Look for numbered pagination first; if the response
      // has a load-more wrapper instead, swap whatever pagination it returns.
      var newPag = doc.querySelector(PAG_SEL) || doc.querySelector('.t4s-pagination') || doc.querySelector('.t4s-prs-footer');
      var curPag = document.querySelector(PAG_SEL) || document.querySelector('.t4s-pagination') || document.querySelector('.t4s-prs-footer');
      if (newPag && curPag) {
        curPag.innerHTML = newPag.innerHTML;
      } else if (curPag && !newPag) {
        curPag.innerHTML = '';
      }

      // Update URL bar (keep &view= in staging so refresh keeps the template)
      if (window.history && window.history.pushState) {
        window.history.pushState({ moda: true }, '', href);
      }

      showLoading(false);

      // Let Kalles re-init lazy images / product item behaviour on new nodes
      if (SP() && typeof SP().reinitProductGridItem === 'function') {
        try { SP().reinitProductGridItem(); } catch (e) {}
      }
      if (window.lazySizes && typeof window.lazySizes.init === 'function') {
        try { window.lazySizes.init(); } catch (e) {}
      }

      // Scroll grid into comfortable view
      var anchor = document.querySelector('.moda-cl-tiles') || curGrid;
      if (anchor) {
        var top = anchor.getBoundingClientRect().top + window.pageYOffset - 120;
        window.scrollTo({ top: top, behavior: 'smooth' });
      }
    }).catch(function () {
      window.location.href = fetchURL;
    });
  }

  function bind() {
    if (window.__modaTilesBound) return;
    window.__modaTilesBound = true;

    // STEP 1: Neutralise tile hrefs so Kalles' pointerdown nav can't fire.
    // Move href → data-moda-href. Our handler reads the data attribute.
    function neutralise() {
      document.querySelectorAll('.moda-cl-tile').forEach(function (tile) {
        var href = tile.getAttribute('href') || '';
        if (href.indexOf('filter.') !== -1 && !tile.hasAttribute('data-moda-href')) {
          tile.setAttribute('data-moda-href', href);
          tile.removeAttribute('href');
          tile.style.cursor = 'pointer';
          tile.setAttribute('role', 'button');
          tile.setAttribute('tabindex', '0');
        }
      });
    }
    neutralise();

    var handled = false;

    function intercept(e) {
      var tile = e.target.closest && e.target.closest('.moda-cl-tile');
      if (!tile) return;

      var href = tile.getAttribute('data-moda-href') || '';
      if (!href || href.indexOf('filter.') === -1) return;
      if (!canAjax()) {
        // no AJAX support — restore href behaviour
        window.location.href = cleanForFetch(href);
        return;
      }

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      if (handled) return;
      handled = true;
      setTimeout(function () { handled = false; }, 400);

      doFilter(href, tile);
    }

    document.addEventListener('pointerdown', intercept, true);
    document.addEventListener('click', function (e) {
      var tile = e.target.closest && e.target.closest('.moda-cl-tile');
      if (tile && tile.hasAttribute('data-moda-href')) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);

    // Keyboard accessibility (Enter / Space on the button-role tiles)
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var tile = e.target.closest && e.target.closest('.moda-cl-tile');
      if (!tile || !tile.hasAttribute('data-moda-href')) return;
      e.preventDefault();
      var href = tile.getAttribute('data-moda-href');
      if (canAjax()) doFilter(href, tile);
      else window.location.href = cleanForFetch(href);
    });

    // Re-neutralise after any AJAX re-render
    document.addEventListener('ntajax:loaded', neutralise);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }

  // Support browser back/forward
  window.addEventListener('popstate', function (ev) {
    if (ev.state && ev.state.moda) {
      var grid = document.querySelector(GRID_SEL);
      if (grid && SP() && typeof SP().getToFetchSection === 'function') {
        var purl = cleanForFetch(location.pathname + location.search);
        if (purl.charAt(0) === '/') purl = window.location.origin + purl;
        fetch(purl, { method: 'GET', headers: { 'Cache-Control': 'no-cache' } })
          .then(function (r) { return r.redirected ? 'NVT_94' : r.text(); })
          .then(function (html) {
            if (!html || html === 'NVT_94') return;
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var ng = doc.querySelector(GRID_SEL);
            if (ng) grid.innerHTML = ng.innerHTML;
            var np = doc.querySelector(PAG_SEL), cp = document.querySelector(PAG_SEL);
            if (np && cp) cp.innerHTML = np.innerHTML;
          });
      }
    }
  });
})();